import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NationalHoliday } from '../beans/national-holiday';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class NationalHolidayService {

	private readonly baseUrl = environment.serviceBaseUrl + '/national-holiday';

	constructor(private http: HttpService) { }

	getAll(): Observable<NationalHoliday[]> {
		return this.http.get<NationalHoliday[]>(this.baseUrl + '/list');
	}

	add(holiday: NationalHoliday): Observable<NationalHoliday> {
		return this.http.post<NationalHoliday>(this.baseUrl + '/add', holiday);
	}

	delete(id: number): Observable<any> {
		return this.http.post<any>(this.baseUrl + '/delete/' + id, {});
	}
}
